export default "__VITE_ASSET__BRN$_azU__"